import Layer from "../Layer";
import React from "react";
import PageHeader from "../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";
import CardPatientSearchFilters from "../Component/Card/PatientSearch/CardPatientSearchFilters";
import CardPatientSearchResults from "../Component/Card/PatientSearch/CardPatientSearchResults";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";
import api from "../Seating/Security/api";
import moment from "moment";

export default class PatientSearch extends Layer {
  constructor(props) {
    super(props);
    this.state.loading = false;
    this.state.params = {};
  }

  /**
   * Render the content.
   */
  renderContent() {
    const handleChange = (params) => {
      this.setState({
        params: {
          ...this.state.params,
          ...params,
        },
      });
    };

    const handleSearch = () => {
      this.setState({ loading: true });
      api
        .send("POST", "/search/omniSearch", {
          Patient_firstName: this.state.params.firstname
            ? this.state.params.firstname
            : null,
          Patient_lastName: this.state.params.lastname
            ? this.state.params.lastname
            : null,
          Patient_dateOfBirth: this.state.params.birthDate
            ? moment(this.state.params.birthDate).format("YYYY-MM-DD")
            : null,
          Patient_phoneNumber: this.state.params.phone
            ? this.state.params.phone.replace(/\D/g, "").slice(-10)
            : null,
          Patient_insurancePolicyNumberOrMBI: this.state.params
            .insurancePolicyNumberOrMBI
            ? this.state.params.insurancePolicyNumberOrMBI
            : null,
        })
        .then((response) => {
          if (response && response.patients && response.patients.length > 0) {
            let updatedRows = response.patients.map((row) => {
              const address = row.address ? row.address : "";
              const cityStateZip = [
                row.city ? row.city : null,
                row.state ? row.state : null,
                row.zipCode ? row.zipCode : null,
              ]
                .filter((part) => part !== null)
                .join(", ");

              const isPediatric = (dateOfBirth) => {
                const age = moment().diff(dateOfBirth, "years");
                return age < 18;
              };

              return {
                ...row,
                dateOfBirth: row.dateOfBirth
                  ? moment(row.dateOfBirth).format("M/D/YYYY")
                  : null,
                patient: `${row.firstName} ${row.lastName}`,
                isPediatric: isPediatric(row.dateOfBirth),
                address: `${address}${cityStateZip ? `\n${cityStateZip}` : ""}`,
                phone: row.phone
                  ? row.phone
                      .replace(/\D/g, "")
                      .slice(0, 10)
                      .replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")
                  : null,
              };
            });

            updatedRows.sort((a, b) => {
              const firstNameComp = a.firstName.localeCompare(
                b.firstName,
                undefined,
                { sensitivity: "base" },
              );
              if (firstNameComp !== 0) return firstNameComp;
              return a.lastName.localeCompare(b.lastName, undefined, {
                sensitivity: "base",
              });
            });

            this.setState({
              rows: updatedRows,
              loading: false,
            });
          } else {
            this.setState({ rows: [], loading: false });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          this.setState({ loading: false });
          NotistackEnqueueSnackbar("Error retrieving patients", {
            variant: "error",
          });
        });
    };

    return (
      <>
        <CardPatientSearchFilters
          onChange={handleChange.bind(this)}
          onConfirm={handleSearch}
          loading={this.state.loading}
          params={this.state.params}
        />
        <CardPatientSearchResults
          rows={this.state.rows || []}
          loading={this.state.loading}
          history={this.props.history}
          onConfirm={handleSearch}
        />
      </>
    );
  }

  renderHeader() {
    const handleClickCreate = () => {
      this.props.history.push({
        pathname: "/patient/create",
      });
    };

    const buttons = [
      <MUIButton
        component="label"
        variant="outlined"
        startIcon={<MUIAddIcon />}
        onClick={handleClickCreate}
      >
        Create New
      </MUIButton>,
    ];
    return <PageHeader title="Patient Search" buttons={buttons} />;
  }

  getMaxWidth() {
    return 1300;
  }
}
